import { Inject } from "typescript-ioc";
import { ILogger } from "Logging/Scripts/ILogger";
import { LoggerFactory } from "Logging/Scripts/LoggerFactory";
import { UiComponentFactory } from "Ui/Scripts/UiComponentFactory";
import { EndConsumerSelectorRowComponent } from "./EndConsumerSelectorRowComponent";
import { Utils } from "Helpers/Scripts/Utils";

export class EndConsumerSelectorRowComponentFactory {
    public get key(): string {
        return "EndConsumerSelectorRowComponentFactory";
    }

    public readonly COMPONENT_SELECTOR: string = ".end-consumer-selector-row-container";
    private _uiComponentFactory: UiComponentFactory;
    protected readonly _logger: ILogger;

    constructor(
        @Inject uiComponentFactory: UiComponentFactory,
        @Inject loggerFactory: LoggerFactory
    ) {
        this._logger = loggerFactory.getLogger(this.key);
        this._uiComponentFactory = uiComponentFactory;
    }

    /**
     * Creates new End Consumer Selector Component instance based on selector.
     * @param selector Element or selector string for context.
     * @returns New instance of End Consumer Selector.
     */
    public create(selector: Element | string): EndConsumerSelectorRowComponent {
        if (!selector) {
            throw new Error("No selector provided");
        }

        return this._uiComponentFactory.createBase(EndConsumerSelectorRowComponent, selector);
    }

    /**
     * Creates End Consumer Selector Row Component instances automatically
     * @param context Element or selector string for context in which method will search for End Consumer Selector Rows.
     */
    public createAll(context: Element | string = "body"): EndConsumerSelectorRowComponent[] {
        const componentElements: Element[] = Utils.find(context, this.COMPONENT_SELECTOR);
        const components: EndConsumerSelectorRowComponent[] = componentElements.map((component) =>
            this.create(component)
        );

        return components;
    }
}
